import { store } from '@utils/configStore'
import { appBannerManagementReducer } from './slice'

export const injectAppBannerManagementStore = () => store.injectReducer('appBannerManagement', appBannerManagementReducer)
